/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Select_File_LabelInputs */



/**
* | output |
* | --- |
* | "Select file" |
*
* @param {Options_Cli_Select_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_select_file_label = /** @type {((inputs?: Options_Cli_Select_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Select_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner un fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите файл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar arquivo")
	return /** @type {LocalizedString} */ ("Select file")
});